export default __webpack_public_path__ + "static/media/L2DAO.d1b333af.svg";